import { Button, Flex, Text } from "@fluentui/react-northstar";
import { ChevronLeft } from "@mui/icons-material";
import React from "react";
import styled from "styled-components";
import { Container } from "../../common/styles";

const HeaderBackButton = ({ title, onBack }) => {
    return (
        <SubHeader fill>
            <Container vAlign="center" gap="gap.small">
                <Button
                    iconOnly={true}
                    icon={<ChevronLeft />}
                    flat
                    onClick={onBack}
                />
                <SubHeaderText content={title} />
            </Container>
        </SubHeader>
    );
};

export default HeaderBackButton;

export const SubHeader = styled(Flex)`
    padding: 12px 24px;
    background-color: #e8ebfa;
`;

export const SubHeaderText = styled(Text)`
    color: #242424;

    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`;
